/** Angular cannot render a component if tenant initialization prevents bootstrap. */
export function showStartupFailure(doc: Document): void {
  const root = doc.querySelector('app-root');
  if (!root) return;
  const panel = doc.createElement('section');
  panel.className = 'container p-4';
  panel.setAttribute('role', 'alert');
  const heading = doc.createElement('h1');
  heading.textContent = 'Unable to load MyMedsPH';
  const message = doc.createElement('p');
  message.textContent = 'Please check your connection and try again. Your saved records have not been changed.';
  const retry = doc.createElement('button');
  retry.type = 'button';
  retry.className = 'btn btn-primary';
  retry.textContent = 'Reload';
  retry.addEventListener('click', () => doc.defaultView?.location.reload());
  panel.append(heading, message, retry);
  root.replaceChildren(panel);
}
